import { Component, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ToastrService } from "ngx-toastr";
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from "@angular/forms";
import { AppSettings } from "../../appsettings";
import { CompanyService } from "../../services/company.service";
import { Company } from "../../models/company";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { HeaderComponent } from "../header/header.component";

@Component({
    selector: "company",
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, HeaderComponent],
    templateUrl: "./company.component.html",
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class CompanyComponent {
    searchText: string;
    companies: Company[];
    companyForm: FormGroup;
    constructor( private companyService: CompanyService, private toastMgr: ToastrService) {
        this.companyForm = new FormGroup({
            name: new FormControl("", [Validators.pattern(AppSettings.alphaNumeric.source), Validators.required])
        });

        this.companyForm.get('name')!.valueChanges
            .pipe(
                debounceTime(700),
                distinctUntilChanged()
            )
            .subscribe(searchTerm => {
                if (!searchTerm || searchTerm.trim().length === 0) {
                    this.companies = new Array();
                    return;
                }
                this.companyService.getCompanies(searchTerm).subscribe(i => this.companies = i);
            });

    }

    addCompany(company: Company): void {
        if (this.companyForm.valid) {
            this.companyService.addCompany(company).subscribe(() => this.toastMgr.success("Company added successfully."));
            this.companies = new Array();
            this.searchText = "";
        }
    }
}


